<mat-dialog-content>
  <t4-container title="{{ 'Turbo.Settings.SparepartsDialog.SpearpartHeadline2' | translate : 'Sparepart' }}">
    <mat-tab-group>
      <mat-tab label="{{ 'Turbo.Settings.SparepartsDialog.GeneralHeadline' | translate : 'General settings' }}">
        <div class="row">
          <div class="col-12 mt-2">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Turbo.Settings.SparepartsDialog.Name' |translate : 'Name' }}</mat-label>
              <input matInput placeholder="Name" [(ngModel)]="viewModel.Title" [disabled]="readonly">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'Turbo.Settings.AddonDialog.Description' | translate : 'Description' }}</mat-label>
              <input matInput placeholder="Description" [(ngModel)]="viewModel.Description" [disabled]="readonly">
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field appearance="outline" style="width: 120px">
              <mat-label>{{ 'Turbo.Settings.AddonDialog.Vat' | translate : 'Vat' }}</mat-label>
              <input matInput placeholder="{{ 'Turbo.Settings.AddonDialog.Vat' | translate : 'Vat' }}" maxlength="3" width="50" [(ngModel)]="viewModel.VATPercentage" [disabled]="readonly">
              <mat-icon matSuffix>%</mat-icon>
            </mat-form-field>
          </div>
          <div class="col-8">
            <label style="margin-top: 10px" class="turboLabel">{{ 'turbo.Settings.EditCategoryDialog.lblSortOrder' | translate : 'Sort order' }}: </label>
            <mat-slider min="0" max="100" step="1"  discrete style="margin-top: 10px; width: 250px" [disabled]="readonly">
              <input matSliderThumb [(ngModel)]="viewModel.SortOrder"/>
            </mat-slider>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="{{ 'Turbo.Settings.AddonDialog.ConnectionsHeadline' | translate : 'Connections' }}">
        <div class="row">
          <div class="col-12 mt-3">
            <mat-checkbox [disabled]="readonly" [(ngModel)]="viewModel.UnlimitedRelations" #unlimited (change)="selectAllRelations(unlimited.checked)">{{ 'Turbo.Settings.AddonDialog.UnlimiteRelations' | translate : 'Use for all models' }}</mat-checkbox>
          </div>
          <div class="col-12" [ngClass]="viewModel.UnlimitedRelations || readonly ? 'not-clickable' : 'clickable'">
            <t4-data-table #tblContent [allowMultiSelect]="true" [rawData]="objectTypes" headline="" matSort matSortActive="Title" [allowPaging]="false" [allowFilter]="false" [allowAdd]="false" [autoGenerateColumns]="false">
              <ng-container matColumnDef="Title">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.EditCategoryDialog.colTitle' | translate : 'Title' }}</mat-header-cell>
                <mat-cell [disabled] *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">
                  <ng-container>{{ row?.Title }}</ng-container>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="Alias">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.EditCategoryDialog.colAlias' | translate : 'Alias' }}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">
                  <ng-container>{{ row.Alias }}</ng-container>
                </mat-cell>
              </ng-container>
            </t4-data-table>
          </div>
        </div>
      </mat-tab>

    </mat-tab-group>
  </t4-container>
</mat-dialog-content>
<mat-dialog-actions *ngIf="!readonly">
  <button mat-raised-button color="primary" style="margin: 5px;" [disabled]="!viewModel.Title" (click)="save()">{{ 'T4.Settings.CreatePricelistDialog.cmdSave' | translate : 'Save' }}</button>
  <button mat-button style="margin: 5px;" [mat-dialog-close]>{{ 'T4.Settings.CreatePricelistDialog.cmdCancel' | translate : 'Cancel' }}</button>
</mat-dialog-actions>
<mat-dialog-actions *ngIf="readonly">
  <button mat-raised-button color="primary" style="margin: 5px;" [mat-dialog-close]>{{ 'T4.Settings.CreatePricelistDialog.cmdClose' | translate : 'Close' }}</button>
</mat-dialog-actions>
